export default "__VITE_ASSET__ZB091yuw__"